import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, MenuController, App } from 'ionic-angular';
import { AppSettings } from '../../services/app-settings';
import { UserServiceProvider } from '../../providers/user-service/user-service';
import { MyApp } from "../../app/app.component";


declare var google;

/**
 * Generated class for the Cb001HomepagePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-cb001-homepage',
  templateUrl: 'cb001-homepage.html',
})
export class Cb001HomepagePage {
  myauthen: any = {};
  homepageLogo: any;
  homepageTitle: any;
  siteBg:any;

  myTracks: any[];
  allTracks: any[];
  selectedTrack: any;
  _appVersion: any;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private userService:UserServiceProvider,
    public viewCtrl: ViewController,
    public menuCtrl: MenuController,
  ) {
    this.myauthen = AppSettings;
    console.log('ionViewDidLoad Cb001HomepagePage');

    this.homepageLogo = this.userService.GetSiteLogo();
    this.homepageTitle = this.userService.GetHomePageTitle();
    this.siteBg = this.userService.GetSiteBackground();

  


  }
  
   

  generateArray(obj) {
    return Object.keys(obj).map((key) => { return { key: key, value: obj[key] } });
  }

  ionViewDidLoad() {
    MyApp.getInstance().constructMainMenu();
    // var activePage = this.navCtrl.getActive();
    // if (!activePage)
    //   return;
    this.viewCtrl.showBackButton(true);
    

  }

  openMenu() {
    this.menuCtrl.open();

  }
  ionviewDidEnter() {
    console.log('ionViewDidLoad Cb001HomepagePage');

    this.navCtrl.insert(0, Cb001HomepagePage);
    this.navCtrl.popToRoot();
  }


   
  ionViewWillEnter() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/cb001-homepage/cb001-homepage.ts